import { render, staticRenderFns } from "./ReplyNotifications.vue?vue&type=template&id=5bf94440&scoped=true&"
import script from "./ReplyNotifications.vue?vue&type=script&lang=js&"
export * from "./ReplyNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ReplyNotifications.vue?vue&type=style&index=0&id=5bf94440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf94440",
  null
  
)

export default component.exports